import { getZoomLevel } from "@utils/zoom.utils";
import styled from "styled-components";

import { isFirefox } from "../global.utils";

// zoom firefox bug hack => firefox first renders svg, and then zooms every single element
// safari and chromium renders svg and that scales it whole
export const StyledLottie = styled.div`
    ${isFirefox() && `svg g {
        clip-path: none !important;
    }
    svg > g {
        transform: scale(var(--zoom));
    }
    svg > g path {
        transform: scale(${1 / getZoomLevel()});
    }`
}`;